export default "ALTER TABLE `credit_cards` ADD `due_on_business_day` integer DEFAULT 0 NOT NULL;\n";